var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "17.026",
        viewBox: "0 0 17.797 17.026",
        width: "17.797",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Icon_feather-edit-3",
            "data-name": "Icon feather-edit-3",
            transform: "translate(-3.5 -3.318)",
          },
        },
        [
          _c("path", {
            attrs: {
              id: "Path_2151",
              d: "M18,30h7.9",
              "data-name": "Path 2151",
              fill: "none",
              stroke: "#1bc5bd",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              transform: "translate(-5.601 -10.656)",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_2152",
              d: "M16.348,4.863A1.862,1.862,0,0,1,18.981,7.5L8.01,18.466l-3.51.878.878-3.51Z",
              "data-name": "Path 2152",
              fill: "none",
              stroke: "#1bc5bd",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }